import { toPng, toSvg } from 'html-to-image';

export interface ImageExportOptions {
  cacheBust?: boolean;
  backgroundColor?: string;
  width?: number;
  height?: number;
}

/**
 * Render a DOM node as PNG and return the data URL.
 */
export async function renderNodeAsPng(
  node: HTMLElement,
  options: ImageExportOptions = {},
): Promise<string> {
  return toPng(node, {
    cacheBust: true,
    backgroundColor: '#ffffff',
    ...options,
  });
}

/**
 * Open the data URL in a new tab, fallback to downloading it if blocked.
 */
export function deliverPng(dataUrl: string, filename: string): void {
  const win = window.open('');
  if (win) {
    win.document.write(`<img src="${dataUrl}" style="max-width:100%;height:auto" />`);
    win.document.title = filename;
  } else {
    const link = document.createElement('a');
    link.download = filename;
    link.href = dataUrl;
    link.click();
  }
}

export { toPng, toSvg };
